module.exports = __webpack_public_path__ + "babc19e3b75dae0e3087f20d5d26fe80.svg";


//////////////////
// WEBPACK FOOTER
// ./static/logo-payoff.svg
// module id = 922
// module chunks = 0